<template>
  <input v-model="searchQuery" placeholder="Sök efter märken eller modeller" class="form-control mb-3" />

  <div v-if="loading"><img width="100" src="https://cdn.gavleenergi.se/img/spinner.svg" /></div>
  <div v-if="error">Error: {{ error }}</div>
  <template v-if="searchQuery.length > 0">

  <div v-if="filteredData.length === 0">
    <p>Hittade inget</p>
  </div>
    <div v-for="item in filteredData" :key="item.label">
      <strong class="label">{{ item.label }}</strong>
      <ul class="list-unstyled">
        <li v-for="model in item.models" :key="model" class="model">{{ item.label }} {{ model }}</li>
      </ul>
    </div>
  </template>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      searchQuery: "",
      loading: false,
      error: null,
    };
  },
  computed: {
    filteredData() {
      const search = this.normalizeString(this.searchQuery);

      return this.data
        .map(item => {
          const filteredModels = item.models.filter(model =>
            this.normalizeString(`${item.label} ${model}`).includes(search)
          );

          return {
            label: item.label,
            models: filteredModels
          };
        })
        .filter(item => item.models.length > 0); // Tar bort tomma kategorier
    }
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;
        const response = await fetch("https://apps.gavleenergi.se/e-tjanster/inc/emulate.php");
        this.data = await response.json();
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },
    normalizeString(str) {
      return str
        .toLowerCase()
        .trim()
        .replace(/\s+/g, " "); // Byt ut flera mellanslag mot ett
    }
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
.label {
  background: #c8c0b9;
  padding: 10px;
  font-weight: bold;
  border-radius: 5px;
}
.model {
  background: #f4f2f0;
  padding: 8px;
  margin: 5px 0;
  border-radius: 5px;
}
</style>
